import {Chart} from './chart';
import {Selection as D3Selection} from 'd3';
import {DescriptionData, MealCategory} from '@/types/data';
import {Constants as constants} from '../config/constants';
import '../../styles/description.css';

export class DishesDescriptionRenderer {
    private foreignContainer = null as unknown as D3Selection<any, any, any, any>;
    private divContainer = null as unknown as D3Selection<any, any, any, any>;

    constructor(private chart: Chart, private data: DescriptionData, private dueDate: string) {
    }

    public render() {
        // this.initContainer();
        // this.renderDishes();
        // this.renderSnacks();
        // this.renderAnnotation();
        // this.normalizeForeignSize();
    }

    private initContainer() {
        this.foreignContainer = this.chart.node.description
            .append('foreignObject')
            .attr('width', 300)
            .attr('height', 800);

        this.divContainer = this.foreignContainer
            .append('xhtml:div')
            .attr('class', 'description-container');
    }

    private renderDishes() {
        for (const category in this.data) {
            if (this.data.hasOwnProperty(category)) {
                const dish = this.data[category];

                if (dish.category !== MealCategory.snack) {
                    const categoryMainDiv = this.divContainer
                      .append('xhtml:div')
                      .attr('class', 'desc-entry');

                    categoryMainDiv
                      .append('xhtml:div')
                      .text(dish.category)
                      .attr('class', 'desc-category');
                    categoryMainDiv
                      .append('xhtml:div')
                      .text(dish.name)
                      .attr('class', 'dish-name');
                    categoryMainDiv
                      .append('xhtml:div')
                      .attr('class', 'desc-separator');
                    categoryMainDiv
                      .append('xhtml:div')
                      .text(dish.ingredients.join(', '))
                      .attr('class', 'ingredients');

                    const stepContainer = categoryMainDiv
                      .append('xhtml:div')
                      .attr('class', 'step-container');

                    dish.prepSteps.map((step, index) => {
                      stepContainer
                        .append('xhtml:div')
                        .attr('class', 'step-entry')
                        .text(`${index + 1}. ${step}`);
                    });
                }
            }
        }
    }

    private renderSnacks() {
        for (const category in this.data) {
            if (this.data.hasOwnProperty(category)) {
                const dish = this.data[category];

                if (dish.category === MealCategory.snack) {
                const categoryMainDiv = this.divContainer
                  .append('xhtml:div')
                  .attr('class', 'snack-entry');

                categoryMainDiv
                  .append('xhtml:div')
                  .text(`Snack: ${dish.name}`)
                  .attr('class', 'snack-name');

                categoryMainDiv
                  .append('xhtml:div')
                  .text('-')
                  .attr('class', 'snack-separator');

                categoryMainDiv
                  .append('xhtml:div')
                  .text(dish.ingredients.join(', '))
                  .attr('class', 'snack-ingredients');
                }
            }
        }
    }

    private renderAnnotation() {
        const annotationDiv = this.divContainer
            .append('xhtml:div')
            .attr('class', 'annotation');

        annotationDiv
            .append('xhtml:div')
            .attr('class', 'annotation-separator');

        annotationDiv
            .append('xhtml:div')
            .text(`All meals best enjoyed before: ${(new Date(this.dueDate)).toDateString()}`);

        annotationDiv
            .append('xhtml:div')
            .text('To substitute microwave for oven, simply heat on low until desired temperature is reached.');

        const contactDataDiv = annotationDiv
            .append('xhtml:div')
            .attr('class', 'annotation-contacts');

        let entryCounter = 0;
        for (const key in constants.contactData) {
            if (constants.contactData.hasOwnProperty(key)) {
              entryCounter++;
              contactDataDiv
                .append('xhtml:div')
                .text(`${constants.contactData[key]}`);

              entryCounter !== Object.keys(constants.contactData).length && contactDataDiv
                .append('xhtml:div')
                .text('●')
                .attr('class', 'annotation-dot');
            }
        }
    }

    private normalizeForeignSize() {
        this.foreignContainer
            .attr('height', (this.divContainer.node() as HTMLDivElement).clientHeight);
    }
}
